export const environment = {
  production: false,
  development: true,
  api_url: '/api'
};
